import { IoMdClose } from "react-icons/io";
import { SmAnimatespin } from "../../components/index";
import { GoCheck } from "react-icons/go";
import Icons from "../../assets/icon";

const Table = ({
  title,
  data,
  setValueHiringRequests,
  setShowPopup,
  handleRequestJob,
  loading,
  loadingToapi,
  requestTitle,
  handleStartChat,
  setApprovedRequests,
  setPopupApprovedRequests,
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const formatted = new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    const [day, month, year] = formatted.split(" ");
    return `${day} ${month}, ${year}`;
  };

  return (
    <div className="">
      {data?.length > 0 ? (
        <div className="w-full overflow-x-auto xs:overflow-x-scroll custom-scrollbar">
          <div
            className={`grid grid-cols-6 lg:min-w-[800px] min-w-[700px] xs:min-w-[500px] text-secondary bg-[#1A1A1A] px-5 py-3 xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular`}
          >
            {title.map((value, index) => (
              <div
                key={index}
                className={`flex items-center xs:gap-x-2 sm:gap-x-2.5 ${
                  index === title.length - 1 ? "justify-center" : ""
                }`}
              >
                {value}
                {/* <img
                  src={Icons.tableTitleIcon}
                  alt="chat"
                  className={`xs:w-3 xs:h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-5 xl:h-5 ${
                    index === title.length - 1 ? "hidden" : "block"
                  }`}
                /> */}
              </div>
            ))}
          </div>
          {data?.map((value, index) => (
            <div
              key={index}
              className={`grid grid-cols-6 lg:min-w-[800px] min-w-[700px] xs:min-w-[500px] text-secondary cursor-pointer rounded-lg my-4 px-5 py-4 gap-3 items-center ${
                index % 2 === 0 ? "bg-[#2A2A2A]" : "bg-transparent"
              }`}
              onClick={() => {
                if (handleStartChat) {
                  setApprovedRequests(value);
                  setPopupApprovedRequests(value);
                } else {
                  setValueHiringRequests(value);
                  setShowPopup(true);
                }
              }}
            >
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {value?.project_title}
              </div>
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                <p className="truncate">{value?.description}</p>
              </div>
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {value?.budget}
              </div>
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {value?.duration}
              </div>
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {formatDate(value?.start_date)}
              </div>
              {handleStartChat ? (
                <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular flex items-center justify-center">
                  <div
                    className="bg-[#787878] xs:w-5 xs:h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7 xl:w-8 xl:h-8 flex justify-center items-center rounded-full cursor-pointer"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleStartChat(
                        value?.company?.user_id,
                        value?.talent?.user_id,
                        value?.id
                      );
                    }}
                  >
                    {loading === value?.id ? (
                      <SmAnimatespin />
                    ) : (
                      <img
                        src={Icons.chatIcon}
                        alt="chat"
                        className="xs:w-3 xs:h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-[18px] xl:h-[18px]"
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className=" xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular flex items-center justify-center gap-2">
                  <div
                    className="text-rejected bg-[#787878] xs:p-1.5 sm:px-2 lg:p-2 rounded-full cursor-pointer"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleRequestJob(value?.id, 2);
                    }}
                  >
                    <p className="xs:text-[8px] sm:text-xs lg:text-sm xl:text-base">
                      {loadingToapi[value?.id] === 2 ? (
                        <SmAnimatespin />
                      ) : (
                        <IoMdClose />
                      )}
                    </p>
                  </div>
                  <div
                    className="text-accepted bg-[#787878] xs:p-1.5 sm:px-2 lg:p-2 rounded-full cursor-pointer"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleRequestJob(value?.id, 1);
                    }}
                  >
                    <p className="xs:text-[8px] sm:text-xs lg:text-sm xl:text-base">
                      {loadingToapi[value?.id] === 1 ? (
                        <SmAnimatespin />
                      ) : (
                        <GoCheck />
                      )}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-secondary capitalize text-center">
          No {requestTitle} request available.
        </p>
      )}
    </div>
  );
};
export default Table;
